export default __webpack_public_path__ + "static/media/Level=2.316924f7.svg";